<template>
  <div class="menu-box-s" v-if="menuData">
    <el-menu class="menu" :class="isCollapse?'hide-btn-box':'open-btn-box'" :unique-opened="true" :default-active="activeIndex" @select="menuClick" :collapse="isCollapse">
      <template v-for="item in menuData">
        <el-sub-menu :index="item.id" v-if="item.hasMenu">
          <template #title>
            <div class="menu-item-text">
<!--
              <i class="iconfont" :class="item.icon?item.icon:'el-icon-none'"></i>
-->
              <span>{{item.name}}</span>
            </div>
          </template>
          <el-menu-item :index="child.url?child.url:''" v-for="child in item.children" :key="child.id">
<!--            <i class="iconfont" :class="child.icon?child.icon:'el-icon-none'"></i>-->
            {{child.name}}
          </el-menu-item>
        </el-sub-menu>
        <el-menu-item :index="item.url?item.url:''"  v-else="">
<!--          <i class="iconfont" :class="item.icon?item.icon:'el-icon-none'"></i>-->
          <span>{{item.name}}</span>
        </el-menu-item>
      </template>
    </el-menu>
    <update-pass  ref="updatePass"></update-pass>
  </div>
</template>

<script>
  import UpdatePass from "./updatePass";
  export default {
    name: "QC_Menu",
    components: {UpdatePass},
    computed:{
      menuData:function(){
        return this.$store.state.user.menuList;
      },
      index:function(){
        return this.$store.state.index+"";//初始值为0
      },
      activeIndex:function(){
        return this.$route.path;
      }
    },
    data() {
      return {
        isCollapse:false,
        itemData:{},
      }
    },
    methods: {
      menuClick(url,path){
        let data = null;
        if(url.indexOf("?type=")>=0){
          let type = this.getUrlKey3(url,"type");
          data = {type:type};
        }
        this.$router.push({path: url,query:data});
      },
      openDownMenu: function() {
        this.isCollapse = !this.isCollapse;
      },
    },
    mounted() {
    }
  }
</script>
<style lang="less" scoped>
  .iconfont{
    margin-right: 12px;
  }
  .menu-box-s{
    display: flex;
    justify-content: center;
    min-height: calc(100vh - 60px);
    .menu{
      width: 200px;
      border-right: none;
      display: flex;
      flex-direction: column;
      align-items: center;
      min-height: calc(100vh - 60px);
      /deep/ .el-submenu{
        width: 200px;
        display: flex;
        flex-direction: column;
      }
      /deep/ li{
        width: 200px;
      }
    }
  }
  [class^=el-icon-qc-]{
    width: 30px;
    height: 30px;
    -webkit-transform: scale(0.7);
  }
  .el-menu-vertical{
    padding-left: 0;
  }
  .menu-item-text{
    width: 150px;
  }
  .open-btn-box{
    width: 230px;
  }
  .hide-btn-box{
    width: 64px;
  }
  .btn-box{
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
    transition:width .35s;
  }
  .top-btn-box{
    width: 64px;
    display: flex;
    height: 56px;
    align-items: center;
    justify-content: center;
    i{
      font-size: 26px;
    }
  }
  .el-menu-item.is-active {
    color: #303133 !important;
    background: #F4F5F7;
    border-radius: 4px;
  }
  .el-menu-item:hover{
    color: #303133 !important;
    background: #F4F5F7 !important;
    border-radius: 4px !important;
  }
</style>
